import FeatureReductionCluster = __esri.FeatureReductionCluster;

/**
 * Default ArcGIS feature clustering configuration with a 60px radius and a 16px Noto Sans bold text label showing cluster counts in black with a white halo.
 */
export const defaultFeatureReduction: FeatureReductionCluster = {
  type: 'cluster',
  clusterMinSize: 25,
  clusterMaxSize: 25,
  // maxScale: 10000,
  clusterRadius: 60,
  labelingInfo: [
    {
      deconflictionStrategy: 'none',
      // @ts-ignore
      labelExpressionInfo: {
        expression: "Text($feature.cluster_count, '###')"
      },
      symbol: {
        type: 'text',
        // @ts-ignore
        color: 'black',
        // @ts-ignore
        haloColor: 'rgba(255,255,255,255.25)',
        // @ts-ignore
        haloSize: '1px',
        // @ts-ignore
        yoffset: '5px',
        font: {
          family: 'Noto Sans',
          // @ts-ignore
          size: '16px',
          weight: 'bold'
        }
      },
      labelPlacement: 'center-center'
    }
  ]
};
/**
 * Alternative ArcGIS feature clustering configuration with a 60px radius and a 12px Noto Sans bold white text label (no halo) with a -10px y-offset for cluster counts.
 */
export const defaultFeatureReductionV2: FeatureReductionCluster = {
  type: 'cluster',
  clusterMinSize: 25,
  clusterMaxSize: 25,
  // maxScale: 10000,
  clusterRadius: 60,
  labelingInfo: [
    {
      deconflictionStrategy: 'none',
      // @ts-ignore
      labelExpressionInfo: {
        expression: 'Text($feature.cluster_count, \'###\')'
      },
      symbol: {
        type: 'text',
        // @ts-ignore
        color: '#ffffff',
        // @ts-ignore
        haloColor: 'rgba(255,255,255,255.25)',
        // @ts-ignore
        haloSize: '0px',
        // @ts-ignore
        yoffset: '-10px',
        font: {
          family: 'Noto Sans',
          // @ts-ignore
          size: '12px',
          weight: 'bold'
        }
      },
      labelPlacement: 'center-center'
    }
  ]
};

